import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import Isvg from 'react-inlinesvg'

import { LogoHeader } from 'components/header'
import { BaseButton } from 'components/button'
import TextLink from 'components/text_link/text_link'
import styles from './FullOverlay.scss'

class FullOverlay extends PureComponent {

	render() {

		return (
			<div
				styleName={classNames({
					wrapper: true,
					'wrapper--is-animated': this.props.shouldShowAnimation,
				})}
				style={{
					animationDelay: `${this.props.animationDelay}s`,
				}}

			>
				{this.props.shouldShowHeader &&
					<div styleName='header'>
						<LogoHeader border={true} />
						{ this.props.shouldShowCancelButton &&
							<button styleName='header-button-close' onClick={this.props.cancelHandler}></button>
						}
					</div>
				}

				<section styleName={classNames({
					content: true,
					'content--full-height': !this.props.shouldShowHeader,
				})}>
					{ this.props.notificationText &&
						<div styleName='information-bar'>
							<p styleName='information-text'>
								<Isvg styleName='information-icon' src={this.props.notificationIcon} cacheGetRequests={true} />
								{this.props.notificationText}
							</p>
						</div>
					}
					<section styleName='main-content'>
						<div
							styleName='main-content-wrapper'
							style={{
								minHeight: this.props.minHeight,
							}}
						>
							{ (this.props.title || this.props.strongTitle) &&
								<div styleName='content-header'>
									<h1 styleName='title'>{this.props.title}</h1>
									<h2 styleName='subtitle'>{this.props.strongTitle}</h2>
								</div>
							}
							<div styleName='asset'>
								{this.props.assetLogoMessage &&
									<img src={this.props.assetLogoMessage} styleName='asset-img-logo' />
								}
								<div
									styleName='assetSource'
									style={{
										width: this.props.assetWidth,
										height: this.props.assetHeight,
									}}
								>
									{this.props.assetSource}
								</div>
							</div>
							{ this.props.primaryTextButton &&
								<div styleName='button-container'>
									<BaseButton
										pill={true}
										bgColor={this.props.bgColor}
										fontColor={this.props.fontColor}
										size='big'
										onClick={this.props.primaryActionHandler}
									>
										{this.props.primaryTextButton}
									</BaseButton>
								</div>
							}
							{ this.props.secondaryTextButton &&
								<div styleName='link-container'>
									<TextLink onClick={this.props.secondaryActionHandler}>
										{this.props.secondaryTextButton}
									</TextLink>
								</div>
							}
						</div>
					</section>
				</section>
			</div>
		)
	}
}

FullOverlay.propTypes = {
	animationCompleted: PropTypes.func,
	assetHeight: PropTypes.string,
	assetLogoMessage: PropTypes.string,
	assetSource: PropTypes.object,
	assetWidth: PropTypes.string,
	bgColor: PropTypes.string,
	fontColor: PropTypes.string,
	headerWithBorder: PropTypes.bool,
	minHeight: PropTypes.string,
	notificationIcon: PropTypes.string,
	notificationText: PropTypes.string,
	primaryActionHandler: PropTypes.func,
	primaryTextButton: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	secondaryActionHandler: PropTypes.func,
	secondaryTextButton: PropTypes.string,
	shouldShowAnimation: PropTypes.bool,
	shouldShowHeader: PropTypes.bool,
	strongTitle: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	animationDelay: PropTypes.number,
	shouldShowCancelButton: PropTypes.bool,
	cancelHandler: PropTypes.func,
}

FullOverlay.defaultProps = {
	animationCompleted: () => {},
	assetHeight: '',
	assetLogoMessage: '',
	assetSource: {},
	assetWidth: '',
	bgColor: 'blue',
	fontColor: 'white',
	headerWithBorder: false,
	minHeight: null,
	notificationIcon: '',
	notificationText: '',
	primaryActionHandler: () => {},
	primaryTextButton: '',
	secondaryActionHandler: () => {},
	secondaryTextButton: '',
	shouldShowAnimation: true,
	shouldShowHeader: true,
	strongTitle: '',
	title: '',
	animationDelay: 1,
	shouldShowCancelButton: false,
	cancelHandler: () => {},
}

export default CSSModules(FullOverlay, styles, {allowMultiple: true})
